import PropTypes from 'prop-types';
import React from 'react';
import { Tab, Tabs, Button } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import { withTranslation } from 'react-i18next';

import LexicalParams from './LexicalParams';
import OccurrencesParams from './OccurrencesParams';
import SearchAreaParams from './SearchAreaParams';
import AlrParams from './AlrParams';
import ImportParams from './ImportParams';
//import { FormatSizeSharp } from '@material-ui/icons';


class AdvancedParams extends React.PureComponent {

  state = {
    // presentational
    selectedTabId: 'search',
    params: this.props.params,
    changed: false,
    // params state
    // searchAreaParamValues: {
    //   maxElapsedTime: 1000,
    //   nbMax2Parse: 2000,
    //   percent2Parse: 100,
    //   nbMaxFound: 2000,
    //   completeExtraction: 0,
    //   noDuplicate: 0,
    //   computeKullbackLeibler:0,
    //   timeStatsSpanType: "Y",
    //   timeStatsSpanLen: 1,
    // },

    // occurrencesParamValues: {
    //   nodeMaskType: 'surface',
    //   nodeMaskFeatures: ['l', 'c'],
    //   collocMaskFeatures: ['l', 'c'],
    //   kwicNode: '#1',
    //   fullConcordSpan : 0,
    //   calcConcord : 1,
    //   calcMap : 0,
    //   concordSpan: '40',
    //   fromPivotOnly: 0,
    //   realizeOnlyOne:0,
    //   runMultivar: 0,
    //   minWordSketchLLR: 5,
    //   maxWordSketchLength: 15,
    //   computeEstimatedFreq: 1,
    //   dispCriterion: 'title',
    //   otherDispCriteria: ['year','sub_genre','collection','author']
    //   assocMeasure:'am.log.likelihood' | 'am.pmi' | 'am.z.score' | 'am.t.score'
    //   innerCollocs: 'am.log.likelihood' | 'am.pmi' | 'am.z.score'
    //   minNbCooc: 3,
    //   maxCooc: 200,
    //   calcContextTrees:0,
    // },

    // lexicalClassesParamValue: {
    //   lexicalClasses: '',
    //   cosSimilarityThreshold: 0.5
    // }
      
    // alrParamValues: {
    //   collocCatFilter: "^(N|V|ADV|ADJ)",
    //   freqMinAlr: [20,15,10,10,10,10],
    //   dispMinAlr: 2,
    //   minSize: 3,
    //   maxSize: 8,
    //   amThreshold: 10.83,
    //   maxNbCollocs: 30,
    //   minFreqChildrenRatio4Deduplicating: 0.5,
    //   useCollig: 1
    // }

    // importParamValues: {
    //  "extractPatterns":0,
    //  "extractLexicometry":0,
    //  "supprUnderScore":0,
    //  "maxSpanSize":300,
    //  "useLemma4Repet":0,
    //  "idSentPattern":"",
    //  "timeIntPattern":"",
    //  "speakerPattern":""
    //}

  };

  handleTabChange = navbarTabId => this.setState({ selectedTabId: navbarTabId });

  handleValueChange = (tabName, paramName, newValue) => {
    // l'initialisation de state.params n'est pas encore faite.
    // on la fait maintenant
    const params=this.state.params ? this.state.params : this.props.params;

    const tabParams = params[tabName];
    const newTabParams = { ...tabParams, [paramName]: newValue };
    // if (newValue['sizeRange']) {
    //   newValue['minSize']=newValue['sizeRange'][0];
    //   newValue['maxSize']=newValue['sizeRange'][1];
    //   delete(newValue['sizeRange']);
    // }
    // console.log(newTabParams);
  
    this.setState({ changed:true, params:{ ...params, [tabName]: newTabParams }});
  };

  validateParams = () => {
    this.props.onParamsReady({params: this.state.params});
    this.setState({ changed:false });
  };

  render() {
    const t = this.props.t;
    const {
      selectedTabId
    } = this.state;
    
    const params=this.state.params ? this.state.params : this.props.params;

    const searchAreaParams = params ? 
      <SearchAreaParams
        values={params.searchAreaParamValues}
        onValueChange={this.handleValueChange}
      />
    :null;
   
    const occurrencesParams = params ?
      <OccurrencesParams
        values={params.occurrencesParamValues}
        onValueChange={this.handleValueChange}
      />
    :null;

    const lexicalParams = params?
      <LexicalParams
        value={params.lexicalClassesParamValues}
        onValueChange={this.handleValueChange}
      />
    : null;

    const alrParams = params?
      <AlrParams
        values={params.alrParamValues}
        onValueChange={this.handleValueChange}
      />
    :null;

    const importParams = params ?
      <ImportParams
        values={params.importParamValues}
        onValueChange={this.handleValueChange}
      />
    :null;

    return (
      <>
        <Paper elevation={3} style={{width:"800px",padding:"30px"}}>
          {this.state.changed &&
            <Button onClick={this.validateParams}>{t('validateChanges')}</Button>
          }
          <Tabs onChange={this.handleTabChange} selectedTabId={selectedTabId} >
            <Tab id='search' title={t('searchSpace')} panel={searchAreaParams} />
            <Tab id='cc' title={t('concordancesAndOccurrences')} panel={occurrencesParams} />
            <Tab id='lex' title={t('lexicalClasses')} panel={lexicalParams} />
            <Tab id='alr' title={t('alr')} panel={alrParams} />
            <Tab id='import' title={t('import')} panel={importParams} />
          </Tabs>
        </Paper>
      </>
    );
  }
}

AdvancedParams.propTypes = {
  params: PropTypes.object,
  onParamsReady: PropTypes.func,
};

export default withTranslation()(AdvancedParams);